import { AxiosResponse } from 'axios';
import _, { Omit } from 'lodash';
import http from './http';
import { getAuthData } from './tokenData';
import { User } from '@/dtos/user';




export async function addUser(user: User): Promise<void> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'team.addUser',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        body: user
      }
    })
    .then(res => res.data.data);
}

export async function updateUser(user: User): Promise<void> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'team.updateUser',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        body: user
      }
    })
    .then(res => res.data.data);
}




export async function removeUser(userEmail): Promise<void> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'team.removeUser',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        body: { email: userEmail }
      }
    })
    .then(res => res.data.data);
}
export async function updatePrice({pair,price}): Promise<void> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'team.updatePrice',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        body: { pair,price }
      }
    })
    .then(res => res.data.data);
}
